// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2EjDO","buttons":"RemoveExpirationActionButtons_buttons__HI0Wk"};